import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { DeviceDataStore } from '../../services/device-data.store';

/**
 * Guard to restrict device child routes based on connection state.
 * If device is disconnected (disconnected=true query param), only allow device-twin route.
 * All other routes will be redirected to device-twin.
 */
export const deviceConnectionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const store = inject(DeviceDataStore);
  
  // Check if disconnected flag is present in query params
  const isDisconnected = route.queryParamMap.get('disconnected') === 'true';
  const deviceId = route.queryParamMap.get('deviceId');
  
  // If disconnected and not on twin route, redirect to twin
  if (isDisconnected) {
    const currentPath = route.routeConfig?.path;
    
    if (currentPath !== 'device-twin') {
      // Store connection state
      store.setConnectionState('Disconnected');
      
      // Redirect to twin page with same query params
      return router.createUrlTree(['/device/device-twin'], {
        queryParams: { deviceId, disconnected: 'true' }
      });
    }
    
    // Store connection state for twin page
    store.setConnectionState('Disconnected');
  } else {
    // Connected device
    store.setConnectionState('Connected');
  }
  
  return true;
};
